import api from '@/libs/axiosInstance';
import type { ApiResponse, WishlistCreator } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';

interface BatchCheckParams {
  platform: string;
  platformUserIds: string[];
  sourceCreatorIds?: string[];
}

// Each entry is either null (not in wishlist) or the WishlistCreator object
type BatchCheckResponse = Record<string, WishlistCreator | null>;

export const fetchBatchWishlistCheck = async (
  params: BatchCheckParams
): Promise<BatchCheckResponse> => {
  const { data } = await api.post<ApiResponse<BatchCheckResponse>>(
    '/dashboard/wishlist/batch-check',
    params
  );

  if (!data.data) {
    throw new Error('Invalid response structure');
  }

  return data.data;
};

export const useBatchWishlistCheckQuery = (
  platformUserIds: string[],
  platform: string = 'instagram',
  enabled = true,
  sourceCreatorIds: string[] = []
) => {
  const hasWishlistIdentity = platformUserIds.length > 0 || sourceCreatorIds.length > 0;

  return useQuery<BatchCheckResponse, Error>({
    queryKey: ['wishlist', 'batch-check', platform, platformUserIds, sourceCreatorIds],
    queryFn: () => fetchBatchWishlistCheck({ platform, platformUserIds, sourceCreatorIds }),
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: enabled && hasWishlistIdentity,
  });
};
